import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ql-snow" }
const _hoisted_2 = {
  id: "editor-preview-container",
  class: "ql-editor only-view-editor"
}
const _hoisted_3 = ["innerHTML"]

import { watch } from 'vue'
import { onMounted } from 'vue-demi'
import { purifyContent } from '@/utils'

export default /*#__PURE__*/_defineComponent({
  props: {
  content: String,
},
  setup(__props) {

const props = __props



onMounted(() => {
  modifyImageComponent()
})

watch(
  () => props?.content,
  () => {
    modifyImageComponent()
  }
)

const modifyImageComponent = () => {
  setTimeout(() => {
    const linkableComponents = document.querySelectorAll('#editor-preview-container a')
    linkableComponents.forEach((linkableComponent) => {
      linkableComponent.setAttribute('target', '_blank')
    })
  }, 300)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        innerHTML: _unref(purifyContent)(__props.content)
      }, null, 8, _hoisted_3)
    ])
  ]))
}
}

})